
import { useState } from 'react';
import { Activity } from '@/types/program';

export const useDragAndDrop = (
  activities: Activity[], 
  reorderActivities: (activities: Activity[]) => Promise<void>
) => {
  const [draggedIndex, setDraggedIndex] = useState<number | null>(null);
  const [dragOverIndex, setDragOverIndex] = useState<number | null>(null);

  const handleDragStart = (e: React.DragEvent, index: number) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/html', '');
  };

  const handleDragOver = (e: React.DragEvent, index: number) => {
    e.preventDefault();
    setDragOverIndex(index);
  };

  const handleDragLeave = () => {
    setDragOverIndex(null);
  };

  const handleDrop = async (e: React.DragEvent, dropIndex: number) => {
    e.preventDefault();
    
    if (draggedIndex === null || draggedIndex === dropIndex) {
      setDraggedIndex(null);
      setDragOverIndex(null);
      return;
    }

    const reorderedActivities = [...activities];
    const draggedActivity = reorderedActivities[draggedIndex];
    
    // Remove the dragged item
    reorderedActivities.splice(draggedIndex, 1);
    
    // Insert at new position
    reorderedActivities.splice(dropIndex, 0, draggedActivity);
    
    // Update order_index for all activities
    const updatedActivities = reorderedActivities.map((activity, index) => ({
      ...activity,
      order_index: index
    }));

    try {
      await reorderActivities(updatedActivities);
    } catch (error) {
      console.error('Failed to reorder activities:', error);
    }

    setDraggedIndex(null);
    setDragOverIndex(null);
  };

  return {
    draggedIndex,
    dragOverIndex,
    handleDragStart,
    handleDragOver,
    handleDragLeave,
    handleDrop
  };
};
